import React from 'react';
import './About.css';

const About = () => {
  return (
    <section className="about">
      <h2>About me</h2>
      <p>
        I am a student at Pokhara University, currently studying Bachelor in computer science and engineering. I'm interested in Artificial Intelligence,
        Machine Learning, Data Science, web development, and practical problem solving.
      </p>
      <p>
        I work with Python, JavaScript, and SQL, and I'm gradually adding more projects to this portfolio as I learn and grow my skills.
      </p>
    </section>
  );
};

export default About;